import styled from '@emotion/styled';

export default styled.p`
    color: ${({ theme }): string => theme.color.bloodyMary};
    text-align: center;
`;
